import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  withMobileDialog,
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  Icon,
  IconButton,
  Typography,
} from '@material-ui/core';

// actions
import { getEvent } from '@pingum/app-state-management/event/actions';
import { getEventNotificationsForEvent } from '@pingum/app-state-management/eventNotification/actions';
import EventDetailPage from '../../../EventDetailPage';

import styles from './styles';

export const transition = React.forwardRef((props, ref) => <Slide direction="up" {...props} ref={ref} />);

export class EventPageDialogComponent extends React.Component {
  constructor(props) {
    super(props);

    if (props.eventId) {
      props.getEvent(props.eventId);
      props.getEventNotificationsForEvent(props.eventId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.eventId && prevProps.eventId !== this.props.eventId) {
      this.props.getEvent(this.props.eventId);
      this.props.getEventNotificationsForEvent(this.props.eventId);
    }
  }

  handleClose = () => {
    this.props.handleClose();
  }

  render() {
    const {
      classes,
      open,
      openInEditMode,
      fullScreen,
      eventId,
      history,
    } = this.props;

    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        TransitionComponent={transition}
        classes={{ paper: classes.dialogPaper }}
        fullScreen={fullScreen}
        maxWidth="lg"
        scroll="paper"
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          <Typography variant="h6" className={classes.title}>Event Detail</Typography>
          <IconButton onClick={() => history.push({ pathname: `/events/${eventId}` })} role="button">
            <Icon>open_in_new</Icon>
          </IconButton>
          <IconButton onClick={this.handleClose}>
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers className={classes.dialogContent}>
          <EventDetailPage
            openInEditMode={openInEditMode}
            hidePageWrapper
          />
        </DialogContent>
      </Dialog>
    );
  }
}

EventPageDialogComponent.propTypes = {
  classes: PropTypes.object,
  getEvent: PropTypes.func,
  getEventNotificationsForEvent: PropTypes.func,
  open: PropTypes.bool,
  openInEditMode: PropTypes.bool,
  handleClose: PropTypes.func,
  eventId: PropTypes.number,
  fullScreen: PropTypes.bool,
  history: PropTypes.object,
};

EventPageDialogComponent.defaultProps = {
  classes: {},
  getEvent: () => {},
  getEventNotificationsForEvent: () => {},
  open: false,
  openInEditMode: false,
  handleClose: () => {},
  eventId: null,
  fullScreen: false,
  history: { push: () => {} },
};

export const mapDispatchToProps = (dispatch) => ({
  getEvent: (id) => dispatch(getEvent(id)),
  getEventNotificationsForEvent: (id) => dispatch(getEventNotificationsForEvent(id)),
});

export default withRouter(withStyles(styles, { withTheme: true })(connect(
  null,
  mapDispatchToProps,
)(withMobileDialog({ breakpoint: 'xs' })(EventPageDialogComponent))));
